import { render, staticRenderFns } from "./companyIndicators.vue?vue&type=template&id=6c99ef4e&scoped=true&"
import script from "./companyIndicators.vue?vue&type=script&lang=js&"
export * from "./companyIndicators.vue?vue&type=script&lang=js&"
import style0 from "./companyIndicators.vue?vue&type=style&index=0&id=6c99ef4e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99ef4e",
  null
  
)

export default component.exports